import React from 'react';
import './Footer.css'
import img1 from '../../assets/myProfilePIC.jpg'

const Footer = () => {
    return (
        <div id='contact' className='footerSection'>
            <footer className="footer mt-20 p-10 grid mx-auto">
                <div className='footerData pl-40'>
                    <div className="avatar">
                        <div className="w-20 rounded-full">
                            <img src={img1} alt='' />
                        </div>
                    </div>
                    <p>Md Farhan Razy</p>
                    <p>BSC in Computer Science and Engineering</p>
                    <p>farhanrazyanik@gmail.com</p>
                    <p>+8801687026563</p>
                </div>
                <div className='pr-10'>
                    <span className="footer-title text-white">Contact me</span>
                    <div className='flex gap-5 mt-2 mb-10'>

                        <a href="https://twitter.com/AinkRazy"
                            className='home_social-icon '
                            target='_blank'
                            rel="noopener noreferrer"
                        >
                            <i class="uil uil-twitter-alt text-white hover:text-black"></i>
                        </a>
                        <a href="https://wa.me/+8801687026563"
                            className='home_social-icon '
                            target='_blank'
                            rel="noopener noreferrer"
                        >
                            <i class="uil uil-whatsapp text-white hover:text-black"></i>
                        </a>
                        <a href="https://www.instagram.com/farhan_r_anik/"
                            className='home_social-icon'
                            target='_blank'
                            rel="noopener noreferrer"
                        >
                            <i class="uil uil-instagram text-white hover:text-black"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/farhan-razy/" className='home_social-icon' target='_blank rel="noopener noreferrer"'>
                            <i class="uil uil-linkedin-alt text-white hover:text-black"></i>

                        </a>
                        <a href="https://github.com/RAZYANIK" className='home_social-icon' target='_blank' rel="noopener noreferrer">
                            <i class="uil uil-github-alt text-white hover:text-black"></i>
                        </a>
                    </div>
                    <div>
                        <p>Copyright © 2022 - All right reserved by MD Farhan Razy</p>
                    </div>
                </div>


            </footer>
            <footer className="footer footer-center p-4 ">

            </footer>
        </div>
    );
};

export default Footer;